// extracted by mini-css-extract-plugin
export default {"wrapper":"NGkUL","image":"Nbzgv","cnImage":"yX5Y_"};